// extracted by mini-css-extract-plugin
export default {"nameText":"GiftCardHistoryTable_nameText__opgKH","emailText":"GiftCardHistoryTable_emailText__y0C2r","statusView":"GiftCardHistoryTable_statusView__NlqWW"};